export const publicVersion = "2.6.1-1-gf168ead3-2026-04-11T13-09-38Z";